import * as React from 'react';
export const LoadingStateContext = React.createContext(null);
export const LoadingStateContextProvider = LoadingStateContext.Provider;
export const LoadingStateContextConsumer = LoadingStateContext.Consumer;
